(() => {
  if (document.documentElement.dataset.ttShowMoreReady) return;
  document.documentElement.dataset.ttShowMoreReady = 'true';
  document.addEventListener('click', (event) => {
    const button = event.target.closest('show-more-button button');
    if (!button) return;
    const parent = button.closest('.parent-display');
    if (!parent) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const items = [...parent.querySelectorAll('.show-more-item')];
    const expand = items.some(item => item.classList.contains('hidden'));
    items.forEach(item => item.classList.toggle('hidden', !expand));
    button.querySelector('.label-show-more')?.classList.toggle('hidden', expand);
    button.querySelector('.label-show-less')?.classList.toggle('hidden', !expand);
    button.setAttribute('aria-expanded', String(expand));
    if (expand) items[0]?.querySelector('input')?.focus();
  }, true);
})();
